import React from 'react';
import { Form, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';
import { SketchPicker } from 'react-color';

import EstaSeguro from '../../../components/funcionales/estaseguro'

const ListaTP = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="tipoPrueba" id="miLista" value={permiteUpdate?argsDocum.tipoPrueba:idLista.tipoPrueba} onChange={(ev)=>handleChange(ev)}>
        <option>PROPIEDADES FISICO</option>
        <option>PROPIEDADES QUIMICAS</option>
        <option>INFRA-ROJO (abs /  mm)</option>
        <option>CONTAMINACION</option>
        <option>DESGASTE DE METALES(ppm)</option>
        <option>CONTAMINANTES EXTERNOS, ppm (mg/kg)</option>  
        <option>ADITIVOS DEL ACEITE, ppm (mg/kg)</option>
        <option>Pruebas especiales</option>
      </select>
    </div>
  )
};
const ListaTV = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="validacion" id="miLista1" value={permiteUpdate?argsDocum.validacion:idLista.validacion} onChange={(ev)=>handleChange(ev)}>
        <option>Seleccionar...</option>
        <option>Rango de % en Aceite nuevo</option>
        <option>Mayor que % de referencia en Aceite nuevo</option>
        <option>Menor que % de referencia en Aceite nuevo</option>
        <option>Mayor que valor único de referencia</option>
        <option>Mayor que 3 valores de referencia</option>
        <option>No se compara</option>
        <option>Valores en sistema</option>
      </select>
    </div>
  )
};
const ListaPR = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="tipoProblema" id="miLista2" value={permiteUpdate?argsDocum.tipoProblema:idLista.tipoProblema} onChange={(ev)=>handleChange(ev)}>
        <option>Aceites</option>
        <option>Mecanismo</option>
      </select>
    </div>
  )
};

class VerPrueba2 extends React.Component {
  state={
    argsDocum: {
      tipoPrueba: this.props.idLista.tipoPrueba,
      descrPrueba: this.props.idLista.descrPrueba,
      unidad: this.props.idLista.unidad?this.props.idLista.unidad:"",
      validacion: this.props.idLista.validacion?this.props.idLista.validacion:"",
      codNorma: this.props.idLista.codNorma?this.props.idLista.codNorma:"",
      descrNorma: this.props.idLista.descrNorma?this.props.idLista.descrNorma:"",
      campoBD: this.props.idLista.campoBD?this.props.idLista.campoBD:"",
      descrArchivo: this.props.idLista.descrArchivo?this.props.idLista.descrArchivo:"",
      tipoProblema: this.props.idLista.tipoProblema?this.props.idLista.tipoProblema:"",
      analisisCon: this.props.idLista.analisisCon?this.props.idLista.analisisCon:"",
      analisisAla: this.props.idLista.analisisAla?this.props.idLista.analisisAla:"",
      analisisPel: this.props.idLista.analisisPel?this.props.idLista.analisisPel:"",
      analisisPre: this.props.idLista.analisisPre?this.props.idLista.analisisPre:"",
      recomenCon: this.props.idLista.recomenCon?this.props.idLista.recomenCon:"",
      recomenAla: this.props.idLista.recomenAla?this.props.idLista.recomenAla:"",
      recomenPel: this.props.idLista.recomenPel?this.props.idLista.recomenPel:"",
      recomenPre: this.props.idLista.recomenPre?this.props.idLista.recomenPre:"",
      _id: this.props.idLista._id
    },
    confirmaAct: false,
    open: false
  }

  // handleChangeComplete = (color) => {
  //   this.setState({ background: color.hex });
  // };

  handleChange = (ev) => {
    if (this.props.permiteUpdate){
        this.setState({confirmaAct: false})
        const argsDocum = this.state.argsDocum
        // if(ev.target.name === "tipoLub"){
        //   console.log(ev.target.name, ev.target.value)
        //   let miLista = document.getElementById("miLista");
        //   argsDocum['tipoLub'] = miLista.options[miLista.selectedIndex].text
        // }else{
        //   console.log(ev.target.name, ev.target.value)
           argsDocum[ev.target.name] = ev.target.value
        // }
        this.setState({argsDocum});
    }
  }
  
  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  render(){
    const {argsDocum, confirmaAct, open} = this.state;
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large hand point down yellow icon"></i>
          Prueba de laboratorio
        </button>
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum):()=>{}}>
            <div className="ui four column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '25%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Tipo de prueba</label>
                    <ListaTP styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>                  
                </div>
                <div className="column" style={{width: '25%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción</label>
                    <Form.Input autoComplete="off" name="descrPrueba" id="descrPrueba" value={this.props.permiteUpdate?argsDocum.descrPrueba:this.props.idLista.descrPrueba} onChange={this.handleChange} placeholder='Descripción' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrPrueba'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: '25%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Unidad</label>
                    <Form.Input autoComplete="off" name="unidad" id="unidad" value={this.props.permiteUpdate?argsDocum.unidad:this.props.idLista.unidad} onChange={this.handleChange} placeholder='Unidad' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'unidad'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>                  
                </div>
                <div className="column" style={{width: '25%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Tipo de validación</label>
                    <ListaTV styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>                      
                </div>
                <div className="column" style={{width: '25%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Campo en BD</label>
                    <Form.Input autoComplete="off" name="campoBD" id="campoBD" value={this.props.permiteUpdate?argsDocum.campoBD:this.props.idLista.campoBD} onChange={this.handleChange} placeholder='Campo en BD' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'campoBD'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: '25%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Código de norma</label>
                    <Form.Input autoComplete="off" name="codNorma" id="codNorma" value={this.props.permiteUpdate?argsDocum.codNorma:this.props.idLista.codNorma} onChange={this.handleChange} placeholder='Código de norma' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'codNorma'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: '25%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Norma</label>
                    <Form.Input autoComplete="off" name="descrNorma" id="descrNorma" value={this.props.permiteUpdate?argsDocum.descrNorma:this.props.idLista.descrNorma} onChange={this.handleChange} placeholder='Norma' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrNorma'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: '25%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Tipo de problema</label>
                    <ListaPR styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field> 
                </div>
                <div className="column" style={{width: '25%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Archivo</label>
                    <Form.Input autoComplete="off" name="descrArchivo" id="descrArchivo" value={this.props.permiteUpdate?argsDocum.descrArchivo:this.props.idLista.descrArchivo?this.props.idLista.descrArchivo:''} onChange={this.handleChange} placeholder='Archivo' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrArchivo'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
              </div>
            </div>
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '100%'}}>
                  <label style={this.props.styles.label}>Análisis para confiable</label>
                  <textarea name="analisisCon" id="analisisCon" 
                    value={this.props.permiteUpdate?argsDocum.analisisCon:this.props.idLista.analisisCon?this.props.idLista.analisisCon:""} 
                    onChange={this.handleChange}>
                  </textarea>
                  <label style={this.props.styles.label}>Análisis para precaución</label>
                  <textarea name="analisisPre" id="analisisPre" 
                    value={this.props.permiteUpdate?argsDocum.analisisPre:this.props.idLista.analisisPre?this.props.idLista.analisisPre:""} 
                    onChange={this.handleChange}>
                  </textarea>
                  <label style={this.props.styles.label}>Análisis para alarma</label>
                  <textarea name="analisisAla" id="analisisAla" 
                    value={this.props.permiteUpdate?argsDocum.analisisAla:this.props.idLista.analisisAla?this.props.idLista.analisisAla:""} 
                    onChange={this.handleChange}>
                  </textarea>
                  <label style={this.props.styles.label}>Análisis para peligro</label>
                  <textarea name="analisisPel" id="analisisPel" 
                    value={this.props.permiteUpdate?argsDocum.analisisPel:this.props.idLista.analisisPel?this.props.idLista.analisisPel:""} 
                    onChange={this.handleChange}>
                  </textarea>
                  <label style={this.props.styles.label}>Recomendaciones para confiable</label>
                  <textarea name="recomenCon" id="recomenCon" 
                    value={this.props.permiteUpdate?argsDocum.recomenCon:this.props.idLista.recomenCon?this.props.idLista.recomenCon:""} 
                    onChange={this.handleChange}>
                  </textarea>
                  <label style={this.props.styles.label}>Recomendaciones para precaución</label>
                  <textarea name="recomenPre" id="recomenPre" 
                    value={this.props.permiteUpdate?argsDocum.recomenPre:this.props.idLista.recomenPre?this.props.idLista.recomenPre:""} 
                    onChange={this.handleChange}>
                  </textarea>
                  <label style={this.props.styles.label}>Recomendaciones para alarma</label>
                  <textarea name="recomenAla" id="recomenAla" 
                    value={this.props.permiteUpdate?argsDocum.recomenAla:this.props.idLista.recomenAla?this.props.idLista.recomenAla:""} 
                    onChange={this.handleChange}>
                  </textarea>
                  <label style={this.props.styles.label}>Recomendaciones para peligro</label>
                  <textarea name="recomenPel" id="recomenPel" 
                    value={this.props.permiteUpdate?argsDocum.recomenPel:this.props.idLista.recomenPel?this.props.idLista.recomenPel:""} 
                    onChange={this.handleChange}>
                  </textarea>
                <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                </div>
                {
                  this.props.errors.length?<Message negative header="Los siguientes errores:"
                  list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }

              </div>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

export default VerPrueba2
